import { useMemo } from 'react';
import type { OpsRole } from './roles';
import {
  hasAnyHrRole,
  hasOpsRole,
  hasPharmacyOpsAccess,
  hasPharmacyTrackingDashboardAccess,
  hasSecurePharmReportsAccess,
  hasSecurePharmDashboardAccess,
  hasSettingsPageAccess,
  hasUnreleasedDepartmentNavAccess,
  isItSysAdmin
} from './roles';
import { useAuthStore } from './useAuthStore';

export function useHasRole() {
  const roles = useAuthStore((s) => s.roles);

  return useMemo(
    () => ({
      roles,
      hasOpsRole: (required: OpsRole) => hasOpsRole(roles, required),
      hasAnyHrRole: () => hasAnyHrRole(roles),
      hasSecurePharmReportsAccess: () => hasSecurePharmReportsAccess(roles),
      hasSecurePharmDashboardAccess: () => hasSecurePharmDashboardAccess(roles),
      isItSysAdmin: () => isItSysAdmin(roles),
      hasSettingsPageAccess: () => hasSettingsPageAccess(roles),
      hasPharmacyOpsAccess: () => hasPharmacyOpsAccess(roles),
      hasPharmacyTrackingDashboardAccess: () => hasPharmacyTrackingDashboardAccess(roles),
      hasUnreleasedDepartmentNavAccess: () => hasUnreleasedDepartmentNavAccess(roles)
    }),
    [roles]
  );
}
